/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_6_NeedInputs */

const en_pc_alt_pick_6_need = /** @type {(inputs: Pc_Alt_Pick_6_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your company needs vendor support, compliance or mobile apps`)
};

const zh_pc_alt_pick_6_need = /** @type {(inputs: Pc_Alt_Pick_6_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公司需要厂商支持、合规认证或移动应用`)
};

/**
* | output |
* | --- |
* | "Your company needs vendor support, compliance or mobile apps" |
*
* @param {Pc_Alt_Pick_6_NeedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_6_need = /** @type {((inputs?: Pc_Alt_Pick_6_NeedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_6_NeedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_6_need(inputs)
	return zh_pc_alt_pick_6_need(inputs)
});
export { pc_alt_pick_6_need as "pc.alt.pick.6.need" }